import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-message-from',
  templateUrl: './message-from.component.html',
  styleUrls: ['./message-from.component.css']
})
export class MessageFromComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
